import React from 'react';
import './style.css';
import { RadioGroup, Radio } from 'react-radio-group';

const Radiobutton = props => {
  return (
    <div className="App-radiobutton">
      <form onSubmit={props.handleSubmit} className="form-check">
        <RadioGroup
          name="radioQuestion"
          value={props.value}
          onChange={props.handleChange}
        >
          {props.answers.map(answer => (
            <div key={answer.uuid} className="form-check">
              <label className="custom-control custom-radio">
                <Radio className="custom-control-input" value={answer.uuid} />
                <span className="custom-control-indicator" />
                <span className="custom-control-description">
                  {answer.answer}
                </span>
              </label>
            </div>
          ))}
        </RadioGroup>
      </form>
    </div>
  );
};

export default Radiobutton;



// WEBPACK FOOTER //
// ./src/comparison/components/Radiobutton/index.js